import { Tabs, TabsList, TabsTrigger } from "@loot-os/ui/components/tabs";
import { useParams, useRouter } from "@tanstack/react-router";

import { useTenantRole } from "../lib/useTenantRole";

/** The two notification pages, each its own route; Marketing is an admin's, as its sends are. */
const NOTIFICATION_TABS = [
  {
    value: "system",
    label: "System",
    to: "/tenants/$tenantId/storefront/notifications/system",
    minRole: "viewer",
  },
  {
    value: "marketing",
    label: "Marketing",
    to: "/tenants/$tenantId/storefront/notifications/marketing",
    minRole: "admin",
  },
] as const;

/**
 * System and Marketing as tabs at the top of both notification pages: the sidebar has one
 * Notifications row, under Storefront, and it opens System. A tab is a link to the other page.
 * A member who can reach only System sees no tabs.
 */
export function NotificationsTabs({ active }: { active: "system" | "marketing" }) {
  const router = useRouter();
  const { tenantId } = useParams({ strict: false }) as { tenantId: string };
  const { can } = useTenantRole();
  const tabs = NOTIFICATION_TABS.filter((tab) => can(tab.minRole));
  if (tabs.length < 2) return null;

  return (
    <Tabs
      value={active}
      onValueChange={(value) => {
        const tab = tabs.find((candidate) => candidate.value === value);
        if (tab) void router.navigate({ to: tab.to, params: { tenantId } });
      }}
    >
      <TabsList>
        {tabs.map((tab) => (
          <TabsTrigger key={tab.value} value={tab.value}>
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
